let lastEventData = null;

const shouldTriggerPriceQuotePresented = (eventData) => {
    let parseEventData;
    if (eventData === lastEventData) {
        // don't fire a price_quote.presented event if nothing has changed since the last time we logged an event
        // (react re-rendering might cause this method to be called multiple times for the same price details)
        return false;
    }
    try {
        parseEventData = JSON.parse(eventData);
    } catch (e) {
        return false;
    }

    lastEventData = eventData;
    return parseEventData;
};

export {shouldTriggerPriceQuotePresented};
